"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorHandling = void 0;
var React = require("react");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var ErrorHandling = function (props) { return (React.createElement(GenericErrorMessage_1.default, { key: 'error' },
    React.createElement(GenericErrorMessage_1.ErrorButton, { onClick: props.fetch }))); };
exports.ErrorHandling = ErrorHandling;
